var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { appendQueryParams, parseSocketIOUrl } from './socket-io';
export const getUrl = (url, optionsRef) => __awaiter(void 0, void 0, void 0, function* () {
    let convertedUrl;
    if (typeof url === 'function') {
        convertedUrl = yield url();
    }
    else {
        convertedUrl = url;
    }
    const parsedUrl = optionsRef.current.fromSocketIO
        ? parseSocketIOUrl(convertedUrl)
        : convertedUrl;
    const parsedWithQueryParams = optionsRef.current.queryParams
        ? appendQueryParams(parsedUrl, optionsRef.current.queryParams)
        : parsedUrl;
    return parsedWithQueryParams;
});
